export function isEmail(isEmailParam?: string) {
  if (
    !isEmailParam?.includes('@') ||
    !isEmailParam?.includes('.') ||
    isEmailParam?.includes(' ')
  ) {
    return false;
  }
  return true;
}

export function isNumeric(str?: string) {
  if (typeof str != 'string') {
    return false;
  }
  return !isNaN(parseFloat(str));
}

export function firstLetterUpperCase(text?: string) {
  if (!text) return '';

  // Verifica quantas palavras existem na string
  const words = text.split(' ');

  // Transforma a primeira letra de cada palavra em maiúscula
  const capitalizedWords = words.map(word => {
    if (word.length === 0) return word; // Verifica se a palavra não é vazia
    return word[0].toUpperCase() + word.slice(1).toLowerCase();
  });

  // Junta as palavras novamente em uma string
  return capitalizedWords.join(' ');
}

export function removeSpecialChars(paramremoveSpecialChars: string) {
  paramremoveSpecialChars = paramremoveSpecialChars.replace('.', '');
  paramremoveSpecialChars = paramremoveSpecialChars.replace('-', '');
  paramremoveSpecialChars = paramremoveSpecialChars.replace('(', '');
  paramremoveSpecialChars = paramremoveSpecialChars.replace(')', '');
  return paramremoveSpecialChars.trim();
}

export function convertToCurrency(value: number) {
  const cem = 100;
  const dois = 2;
  return (Math.round(value * cem) / cem).toFixed(dois).replace('.', ',');
}

export function cpfMask(value?: string) {
  if (value) {
    return value
      .replace(/\D/g, '')
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d{1,2})/, '$1-$2')
      .replace(/(-\d{2})\d+$/, '$1');
  }
  return '';
}

export function phoneMask(value?: string) {
  if (!value) return '';

  // Remove all non-digit characters
  const digits = value.replace(/\D/g, '');

  let country = '';
  let ddd = '';
  let first = '';
  let second = '';

  let rest = digits;
  if (digits.length > 11) {
    // Try to extract country code (1-3 digits)
    if (digits.startsWith('55')) {
      country = '+55 ';
      rest = digits.slice(2);
    } else if (digits.length > 12) {
      country = `+${digits.slice(0, digits.length - 11)} `;
      rest = digits.slice(digits.length - 11);
    }
  }

  // Extract DDD (area code)
  if (rest.length >= 10) {
    ddd = `(${rest.slice(0, 2)}) `;
    rest = rest.slice(2);
  }

  // 9-digit (mobile) or 8-digit (landline)
  if (rest.length === 9) {
    first = rest.slice(0, 5);
    second = rest.slice(5, 9);
  } else if (rest.length === 8) {
    first = rest.slice(0, 4);
    second = rest.slice(4, 8);
  } else if (rest.length > 0) {
    // Fallback for incomplete numbers
    first = rest;
  }

  let formatted = `${country}${ddd}${first}`;
  if (second) {
    formatted += `-${second}`;
  }

  return formatted.trim();
}
